import { Component, EventEmitter, computed, input, Output, forwardRef, signal, Signal } from '@angular/core';
import { DisplayMode, SelectComponent, SelectOptionComponent } from '../select.component';
import { Rarity } from "../../../models/enums";
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseComponent } from '../../base.component';
@Component({
  selector: 'app-select-rarity',
  imports: [FormsModule, SelectComponent, SelectOptionComponent],
  templateUrl: './select-rarity.component.html',
  styleUrl: './select-rarity.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectRarityComponent),
      multi: true
    }
  ]
})
export class SelectRarityComponent extends BaseComponent implements ControlValueAccessor {
  disabled = input<boolean>(false);
  includeNormal = input<boolean>(true);
  includeUnique = input<boolean>(false);
  includeRare = input<boolean>(true);
  lessThanOrEqualTo = input<boolean>(false);
  greaterThanOrEqualTo = input<boolean>(false);
  displayMode = computed(() => this.settings.hideIconsInDropdowns() ? 'textOnly' : 'prefixAndText');

  @Output('selectedValueChange') selectedValueChangeEmitter = new EventEmitter<Rarity>();

  Rarity = Rarity;

  // Internal model for ngModel binding
  internalModel = signal<Rarity>(this.includeNormal() ? Rarity.Normal : Rarity.Magic);

  private onChange = (value: Rarity) => {};
  private onTouched = () => {};

  // ControlValueAccessor implementation
  writeValue(value: Rarity): void {
    this.internalModel.set(value);
  }

  registerOnChange(fn: (value: Rarity) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Input signals are read-only, so we can't set them directly
    // The disabled state is handled by the parent component
  }

  onModelChange(value: string | undefined) {
    if (value !== undefined) {
      const rarityValue = value as Rarity;
      this.onChange(rarityValue);
      this.onTouched();
      this.selectedValueChangeEmitter.emit(rarityValue);
    }
  }
}
